/* eslint react/jsx-props-no-spreading: 0 */
import PropTypes from 'prop-types';
import { Field, ErrorMessage } from 'formik';

import TextError from './TextError';

const Input = (props) => {
  const { label, name, ...rest } = props;
  return (
    <div className="flex flex-1 flex-col gap-1">
      <label className="rounded-t-xl bg-pj-gray-400 px-1 text-lg text-pj-gray-800 duration-300" htmlFor={name}>{label}</label>
      <Field className="w-full rounded-lg border-2 border-pj-primary-100 bg-white p-3 hover:border-pj-primary-300 focus:border-pj-primary-300 focus:outline-none" id={name} name={name} {...rest} />
      <ErrorMessage component={TextError} name={name} />
    </div>
  );
};

Input.propTypes = {
  label: PropTypes.string.isRequired,
  name: PropTypes.string.isRequired,
};

export default Input;
